export default "__VITE_ASSET__e628e818__"